import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#b8ac14',
    primaryDark: '#b8ac14',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/fleetloop-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/fleetloop-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/fleetloop-logo.png',

    availableProducts: ["Schadenmeldung", "smartKV", "Haftpflichtschaden", "Kaskoschaden"],
});